import React from "react";
import { Alert } from "react-bootstrap";

const PASSWORD_RULES = [
  {
    message: "Password is required.",
    test: (password) => typeof password === "string" && password.length > 0,
  },
  {
    message: "Password must be at least 6 characters.",
    test: (password) => typeof password === "string" && password.length >= 6,
  },
  {
    message: "Password must be at most 20 characters.",
    test: (password) => typeof password === "string" && password.length <= 20,
  },
  {
    message: "Password must start with a capital letter.",
    test: (password) => typeof password === "string" && /^[A-Z]/.test(password),
  },
  {
    message: "Password must contain at least one lowercase letter.",
    test: (password) => typeof password === "string" && /[a-z]/.test(password),
  },
  {
    message: "Password must contain at least one digit.",
    test: (password) => typeof password === "string" && /\d/.test(password),
  },
  {
    message: "Password must contain at least one special character.",
    test: (password) =>
      typeof password === "string" && /[^A-Za-z0-9_]/.test(password),
  },
];

export function getPasswordValidationErrors(password) {
  return PASSWORD_RULES.filter((rule) => !rule.test(password)).map(
    (rule) => rule.message
  );
}

export function extractPasswordErrorsFromResponse(data) {
  if (Array.isArray(data?.errors) && data.errors.length > 0) {
    return data.errors;
  }
  if (typeof data?.message === "string" && data.message.includes("\n")) {
    return data.message.split("\n").filter(Boolean);
  }
  if (typeof data?.message === "string" && data.message.trim()) {
    return [data.message];
  }
  return [];
}

export function PasswordErrorsDisplay({ errors }) {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <Alert variant="danger" className="mb-3">
      <div className="fw-semibold mb-1">Password must meet all of the following:</div>
      <ul className="mb-0 ps-3">
        {errors.map((rule) => (
          <li key={rule}>{rule}</li>
        ))}
      </ul>
    </Alert>
  );
}
